import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Cobrancas } from './Cobrancas';
import { ListaDocumentos } from './ListaDocumentos';
import { BaixaRapida } from './BaixaRapida';
import { Recorrencias } from './Recorrencias';
import { CartaoCobrancaCliente } from './ProvedorCobranca';
import { i18n } from './i18n';
import type { TipoDocumento } from './tipos';
import { buscaContas } from './busca-global';

// Listas fixas: a identidade estável evita recalcular filtros a cada renderização.
const A_RECEBER: TipoDocumento[] = ['fatura'];
const A_PAGAR: TipoDocumento[] = ['conta_pagar', 'reembolso'];
const NOTAS: TipoDocumento[] = ['nota_credito'];

const modulo: ModuloWeb = {
  slug: 'contas',
  menu: 'financeiro',
  ordem: 20,
  abas: [
    { chave: 'a-receber', permissao: 'contas.ver', posicao: 10, componente: () => <ListaDocumentos key="a-receber" aba="a-receber" tipos={A_RECEBER} /> },
    { chave: 'a-pagar', permissao: 'contas.ver', posicao: 20, componente: () => <ListaDocumentos key="a-pagar" aba="a-pagar" tipos={A_PAGAR} /> },
    { chave: 'notas-credito', avancada: true, permissao: 'contas.ver', posicao: 50, componente: () => <ListaDocumentos key="notas-credito" aba="notas-credito" tipos={NOTAS} /> },
    { chave: 'recorrencias', permissao: 'contas.ver', componente: Recorrencias, posicao: 40 },
    { chave: 'cobrancas', permissao: 'contas.ver', componente: Cobrancas, posicao: 30 },
  ],
  // Fase 2 (W21, K7): baixa rápida no card "Próximos vencimentos" do Início.
  acoesItemInicio: { proximos_vencimentos: BaixaRapida },
  // Trilha 2 (Pix Sicredi): banco que gera a cobrança das faturas do cliente, na ficha dele.
  cartaoNaFichaCliente: CartaoCobrancaCliente,
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaContas,
};

export default modulo;
